import Footer from "components/global/footer/Footer";
import Header from "components/global/header/Header";
import React from "react";
import { Outlet } from "react-router-dom";

function Layout() {
  return (
    <div>
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
}

export default Layout;
